import { tr } from './tr';
import type { CatalogEntry, CatalogKey, CatalogTree, PluralEntry, TParams } from './types';

const pluralRules = new Intl.PluralRules('tr-TR');
const numberFormat = new Intl.NumberFormat('tr-TR');

// A count with Turkish grouping: 12500 → 12.500.
export function formatNumber(value: number): string {
  return numberFormat.format(value);
}

function pluralForm(count: string | number | undefined): keyof PluralEntry {
  return count !== undefined && pluralRules.select(Number(count)) === 'one' ? 'one' : 'other';
}

// A plural entry picks its form by params.count (`other` without a count). Each {name} becomes
// params[name], a number with Turkish grouping; a placeholder without its param stays as written.
export function createTranslator<C extends CatalogTree>(
  catalog: C,
): (key: CatalogKey<C>, params?: TParams) => string {
  return (key, params = {}) => {
    let node: unknown = catalog;
    for (const part of key.split('.')) node = (node as CatalogTree)[part];
    // The key type guarantees that the path ends at an entry.
    const entry = node as CatalogEntry;
    const text = typeof entry === 'string' ? entry : entry[pluralForm(params.count)];
    return text.replace(/\{(\w+)\}/g, (placeholder, name: string) => {
      const value = params[name];
      if (value === undefined) return placeholder;
      return typeof value === 'number' ? formatNumber(value) : value;
    });
  };
}

export const t = createTranslator(tr);

export type TrKey = CatalogKey<typeof tr>;
